import cx from 'clsx';
import * as React from 'react';

import styles from './LayersWrapper.module.scss';

interface LayersWrapperProps {
  rounded?: 'all' | 'top';
  children?: React.ReactNode;
  containerStyles?: string;
}

const LayersWrapper = ({
  children,
  rounded,
  containerStyles,
}: LayersWrapperProps) => {
  let borderClass;

  if (rounded === 'top') borderClass = styles.roundedTop;
  if (rounded === 'all') borderClass = styles.rounded;

  const containerStyle = containerStyles ? containerStyles : styles.container;

  return (
    <div
      className={cx(containerStyle, borderClass)}
      data-testid="layers-wrapper-element"
    >
      {children}
    </div>
  );
};

export default LayersWrapper;
